import {
  FilterField,
  FilterPanel,
  FilterState,
} from '@/fsd/shared/ui/filter-panel';
import { Dispatch, SetStateAction, useRef, useState } from 'react';
import styles from './MutualSettlementsFilters.module.scss';
import { observer } from 'mobx-react-lite';
import { Button, ButtonSetting } from '@/fsd/shared/ui';
import { TableSettings } from '@/fsd/entities/table/ui/table-settings';
import { mutualSettlementsStore } from '../../model/store/MutualSettlementsStore';
import PlusIcon from '@/fsd/shared/ui/icons/plus';

interface IProps {
  filterFields: FilterField[];
  activeFilters: FilterState;
  setActiveFilters: Dispatch<SetStateAction<FilterState>>;
  handleFilterChange: (newFilters: any) => void;
  handleFilterApply: (newFilters: FilterState | undefined) => void;
  setPage: (page: number) => void;
  filters: FilterState;
}

const MutualSettlementsFilters = observer(
  ({
    filterFields,
    activeFilters,
    setActiveFilters,
    handleFilterChange,
    handleFilterApply,
    setPage,
    filters,
  }: IProps) => {
    const settingsButtonRef = useRef<HTMLButtonElement>(null);
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);

    return (
      <FilterPanel
        fields={filterFields}
        values={activeFilters}
        setValues={handleFilterChange}
        onSearch={handleFilterApply}
        table_name="mutual-settlements"
      >
        <div className={styles.filterButtonsRow}>
          <FilterPanel.PrimaryButtons />
          <div className={styles.buttonsGroup}>
            <Button
              className={styles.createButton}
              onClick={() => mutualSettlementsStore.setIsCreateModalOpen(true)}
            >
              <PlusIcon /> Сверка
            </Button>
            <div className={styles.buttonSettingWrapper}>
              <ButtonSetting
                onClick={() => setIsSettingsOpen((prev) => !prev)}
                buttonRef={settingsButtonRef}
              />
              <TableSettings
                isOpen={isSettingsOpen}
                onClose={() => setIsSettingsOpen(false)}
                columns={Object.values(mutualSettlementsStore.columns)}
                onToggleColumn={mutualSettlementsStore.toggleColumn}
                onToggleAllColumns={mutualSettlementsStore.toggleAllColumns}
                settingsButtonRef={settingsButtonRef}
              />
            </div>
          </div>
        </div>
        <FilterPanel.Filters />
        <FilterPanel.SavedFilters />
      </FilterPanel>
    );
  }
);

export default MutualSettlementsFilters;
